import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
  Collapsible,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";

const ReportDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/logs/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Amount has been added successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  return result ? (
    <Page
      narrowWidth
      backAction={{ onAction: () => navigate("/admin/logs") }}
      title={`${
        result?.causer && result?.causer?.first_name
          ? result?.causer?.first_name
          : ""
      } ${
        result?.causer && result?.causer?.last_name
          ? result?.causer?.last_name
          : ""
      }`}
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br />
                {result?.causer && result?.causer?.first_name
                  ? result?.causer?.first_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br />
                {result?.causer && result?.causer?.last_name
                  ? result?.causer?.last_name
                  : "-"}
              </Text>
              <Text breakWord>
                <b>Created at</b>
                <br />{" "}
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Event</b>
                <br />
                {result?.event ? result?.event : "-"}
              </Text>
              <Text breakWord>
                <b>Amount</b>
                <br />
                {result?.properties && result?.properties?.amount !== null
                  ? result?.properties?.amount
                  : "-"}
              </Text>
              <Text breakWord></Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Description</b>
                <br /> {result?.description ? result?.description : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>Notes</b>
                <br />{" "}
                {result?.properties && result?.properties?.notes
                  ? result?.properties?.notes
                  : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Card>
      </FormLayout>
      {/* <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => {
              setIsSaving(true);
              axios
                .delete(`/app/users/${id}`)
                .then((result) => {
                  navigate("/admin/users");
                })
                .catch((err) => console.log(err));
            }}
          >
            Delete
          </Button>
        }
      /> */}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default ReportDetails;
